var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_usercen"},[_vm._v(" 个人中心，暂未完成 ")])}
var staticRenderFns = []

export { render, staticRenderFns }